import { render, staticRenderFns } from "./WidgetHeaderText.vue?vue&type=template&id=24abbc44&scoped=true&"
import script from "./WidgetHeaderText.vue?vue&type=script&lang=js&"
export * from "./WidgetHeaderText.vue?vue&type=script&lang=js&"
import style0 from "./WidgetHeaderText.vue?vue&type=style&index=0&id=24abbc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24abbc44",
  null
  
)

export default component.exports